import { FlatAspect } from "@/models/HomePageSearchResponse";

// AJB: use slug here?
const SORT_OPTIONS: FlatAspect[] = [
  {
    id: "most-recent",
    label: "Most Recent",
    level: 0,
  },
  {
    id: "updated-desc",
    label: "Recently Updated",
    level: 0,
  },
  {
    id: "created-desc",
    label: "Recently Created",
    level: 0,
  },
  {
    id: "price-asc",
    label: "Price (low to high)",
    level: 0,
  },
  {
    id: "price-desc",
    label: "Price (high to low)",
    level: 0,
  },
  {
    id: "age-asc",
    label: "Age (low to high)",
    level: 0,
  },
  {
    id: "age-desc",
    label: "Age (high to low)",
    level: 0,
  },
];

export default SORT_OPTIONS;
